export default __webpack_public_path__ + "static/media/softwareengineering.f3f89530.png";